'use strict';

const jsInitializer = require('../initializers/js_initializer');

const {
  critModules,
  nonCritModules,
  pageReadyModules,
} = require('./js_modules');

jsInitializer.addJsFiles(critModules, nonCritModules, pageReadyModules);
